<script lang="ts" setup>
import { computed } from 'vue';
import { maatschappijen } from '../herstellers-data';
import ContactLink from '../components/ContactLink.vue';

function getWebsiteLabel(website: string): string {
  return website.replace(/^(https?:\/\/)?(www\.)?/, '').split('/')[0];
}

function getMaatschappijLogoUrl(maatschappijId: string): string {
  return `/mijimages/klein/${maatschappijId}.png`;
}

const gesorteerdeMaatschappijen = computed(() =>
  maatschappijen.map((maatschappij) => ({
    ...maatschappij,
    logoUrl: getMaatschappijLogoUrl(maatschappij.logo),
    categorieen: maatschappij.categorieen.toSorted((a, b) => a.titel.localeCompare(b.titel, 'nl')),
  })),
);
</script>

<template>
  <div class="space-y-6">
    <div
      v-for="maatschappij in gesorteerdeMaatschappijen"
      :key="maatschappij.logo"
      class="overflow-hidden rounded-lg border border-grey-200 bg-white shadow-sm"
    >
      <figure class="flex items-center gap-4 border-b border-grey-200 bg-grey-50 px-6 py-4">
        <div
          class="flex h-12 w-32 items-center justify-center rounded border border-grey-200 bg-white p-2"
        >
          <img
            :src="maatschappij.logoUrl"
            :alt="maatschappij.naam"
            class="max-h-full max-w-full object-contain"
            loading="lazy"
          />
        </div>
        <figcaption class="text-lg font-semibold text-grey-800">{{ maatschappij.naam }}</figcaption>
      </figure>

      <div class="grid grid-cols-[repeat(auto-fit,minmax(320px,1fr))] gap-6 p-6">
        <div v-for="categorie in maatschappij.categorieen" :key="categorie.titel" class="space-y-3">
          <h2 class="font-bold uppercase">
            {{ categorie.titel }}
          </h2>
          <div class="space-y-4">
            <div v-for="contact in categorie.contacten" :key="contact.naam" class="">
              <p class="mb-2 font-semibold">
                {{ contact.naam }}
                <span v-if="contact.opmerking" class="block text-sm font-normal text-grey-500">
                  {{ contact.opmerking }}
                </span>
              </p>
              <div class="space-y-1 text-sm">
                <ContactLink v-if="contact.telefoon" type="phone" :value="contact.telefoon" />
                <ContactLink
                  v-if="contact.website"
                  type="website"
                  :value="contact.website"
                  :label="getWebsiteLabel(contact.website)"
                />
                <ContactLink v-if="contact.email" type="email" :value="contact.email" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
